import {FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE, SET_FAV_ICON, SET_LOGO, SET_DATE_FORMAT, SET_CURRENCY, SET_TIME_CALCULATION_MODE, SET_AUTO_SHIFT_ENABLED} from '../../constants/ActionTypes'
import {TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH, IS_PASSWORD_CHANGE, ATTENDANCE_UPDATED} from "../../constants/ActionTypes";
import { TAB_SIZE } from "../../constants/ThemeSetting";

// Fallback used until the company's configured Date Format setting has been
// fetched (or if the fetch fails) - must match the server default.
export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';

// Fallback currency (ISO 4217) until the company's setting has been fetched -
// must match the server default on CompanyModel.currency.
export const DEFAULT_CURRENCY = 'INR';

// Fallback used until the company's currently-effective time calculation mode
// has been fetched (or if the fetch fails) — "hours" is also the server
// resolver's own no-history-recorded default (see
// docs/minute-wise-calculation/12-effective-dated-mode-resolution.md), so this
// keeps Hours-mode behavior identical to before this feature existed.
export const DEFAULT_TIME_CALCULATION_MODE = 'hours';

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  navCollapsed: false,
  width: window.innerWidth,
  pathname: '/',
  favicon : '',
  logo : '',
  isPassword:false,
  attendanceUpdated: 0,
  dateFormat: DEFAULT_DATE_FORMAT,
  currency: DEFAULT_CURRENCY,
  timeCalculationMode: DEFAULT_TIME_CALCULATION_MODE,
  autoShiftEnabled: false
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      return {
        ...state,
        pathname: action.payload.location.pathname,
        // Close sidebar on mobile when navigating, keep desktop behavior unchanged
        navCollapsed: state.width < TAB_SIZE ? false : state.navCollapsed
      }
    }
    
    case WINDOW_WIDTH: {
      const isCurrentlyMobile = state.width < TAB_SIZE;
      const isBecomingMobile = action.width < TAB_SIZE;
      
      return {
        ...state,
        width: action.width,
        navCollapsed: (!isCurrentlyMobile && isBecomingMobile && state.navCollapsed) 
          ? false 
          : state.navCollapsed
      };
    }

    case TOGGLE_COLLAPSED_NAV: {
      return {
        ...state,
        navCollapsed: action.navCollapsed
      }
    }

    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }

    case FETCH_SUCCESS: {
      return {...state, error: '', message: '', loading: false};
    }

    case SHOW_MESSAGE: {
      return {...state, error: '', message: action.payload, loading: false};
    }

    case FETCH_ERROR: {
      return {...state, loading: false, error: action.payload, message: ''};
    }

    case HIDE_MESSAGE: {
      return {...state, loading: false, error: '', message: ''};
    }

    case SET_FAV_ICON : {
      return {...state, favicon : action.payload, loading: false}
    }

    case SET_LOGO : {
      return {...state, logo : action.payload, loading: false}
    }
    
    case IS_PASSWORD_CHANGE:{
      return{...state,isPassword:action.payload}
    }

    case ATTENDANCE_UPDATED: {
      return { ...state, attendanceUpdated: state.attendanceUpdated + 1 };
    }

    case SET_DATE_FORMAT: {
      return { ...state, dateFormat: action.payload || DEFAULT_DATE_FORMAT };
    }

    case SET_CURRENCY: {
      return { ...state, currency: action.payload || DEFAULT_CURRENCY };
    }

    case SET_TIME_CALCULATION_MODE: {
      return { ...state, timeCalculationMode: action.payload || DEFAULT_TIME_CALCULATION_MODE };
    }

    case SET_AUTO_SHIFT_ENABLED: {
      return { ...state, autoShiftEnabled: action.payload === true };
    }

    default:
      return state;
  }
}
export default reducer;